module.exports = __webpack_public_path__ + "img/banner_alarm_icon.1186d75d.svg";